import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const layoutAnimation = trigger('openClose', [
  state('true', style({ opacity: 1 })),
  state('false', style({ opacity: 0 })),
  transition('false <=> true', [animate('300ms ease-out')]),
]);
